import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CadastroPage } from './cadastro';
import { CadastroPageProvider } from './cadastro.provider';
import { ListasProvider } from '../../providers/listas/listas';
import { Camera } from '@ionic-native/camera';
import { MediaProvider } from '../../providers/media/media';
import { FilePath } from '@ionic-native/file-path';
import { BrMaskerModule } from 'brmasker-ionic-3';

@NgModule({
  declarations: [
    CadastroPage,
  ],
  imports: [
    IonicPageModule.forChild(CadastroPage),
    BrMaskerModule
  ],
  providers: [
    CadastroPageProvider,
    ListasProvider,
    Camera,
    MediaProvider,
    FilePath
  ]
})
export class CadastroPageModule {}



// WEBPACK FOOTER //
// ./src/pages/cadastro/cadastro.module.ts